export default {
  tags(state) {
    return state.tags;
  }
};
